module.exports = __webpack_public_path__ + "img/Scenarios_Hot_Growth.98232ea7.jpg";